<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
            h1.title Corporativo
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-3(v-show="verRegistro")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Registro de Entradas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Visitas/Corpo/") Entrar
          .column.is-3(v-show="verReportes")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Reportes
                br
                a.button.is-dark.is-rounded(@click="irReportes") Entrar
          .column.is-3(v-show="verGIA")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-tag.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Sistemas e Instrumentación
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/HomeGia") Entrar
          .column.is-3(v-show="verSoporte")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-tools.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Soporte
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Soporte") Entrar
          .column.is-3(v-show="verResponsivas")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Responsivas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Responsivas") Entrar
          .column.is-3(v-show="verInventarios")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-cart-arrow-down.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Inventarios
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(:to="isAlmacenistaCede ? '/Inventario':'/Inventario/Asignaciones'") Entrar
          .column.is-3(v-show="verCombustibles")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-car.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Transportes
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Transportes") Entrar
          .column.is-3(v-show="verSolicitudes")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-car.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Solicitudes
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Solicitudes/") Entrar
          .column.is-3(v-show="verVideos")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-video.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 DucterTube
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/ducterTube/") Entrar
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import { mapState } from 'vuex'
import InventarioServices from '@/services/inventario/inventario'
import ticketServices from "@/services/soporte/tickets"

export default {
  name: 'HomeCORP',
  components: { Loader, NavBarCORP },
  data () {
    return {
      isLoading: false,
      verResponsivas: false,
      verRequisiciones: false,
      verRegistro: false,
      verReportes: false,
      verSoporte: false,
      verInventarios: false,
      verCombustibles: false,
      verSolicitudes: false,
      verGIA: false,
      verVideos: false,
      isAlmacenistaCede: false,
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {

        if (this.permisos.permisos_videos == 1) {
          this.verVideos = true
        }
        
        switch (this.userLogin.cargo) {
          case '001':
            console.log('001 - gerente')
            this.verResponsivas = true
            this.verReportes = true
            this.verSoporte = true
            this.verInventarios = true
            this.verCombustibles = true
            this.verSolicitudes = true
            break
          case '003':
            console.log('003 - Gerente GIA')
            this.verReportes = true
            this.verSoporte = true
            this.verResponsivas = true
            this.verInventarios = true
            break
          case '2100':
            console.log('2100 - Contralora')
            this.verResponsivas = true
            this.verRequisiciones = true
            this.verInventarios = true
            break
          case '330':
            console.log('330 - sistemasUser')
            this.verGIA = true
            this.verInventarios = true
            this.verSoporte = true
            break
          case '320':
            console.log('320 - Capital HUmano')
            this.verResponsivas = true
            break
          case '323':
            console.log('323 - Auditor')
            this.verResponsivas = true
            this.verInventarios = true
            this.isAlmacenistaCede = true
            this.verCombustibles = true
            break
          case '324':
            console.log('324 - Auditor')
            this.verInventarios = true
            this.isAlmacenistaCede = true
            break
          case '331':
            console.log('331 - Almacenista GIA')
            this.verGIA = true
            this.verReportes = true
            this.verResponsivas = true
            this.verInventarios = true
            break
          case '332':
            console.log('332 - Sistemas Almacenista')
            this.verGIA = true
            this.verReportes = true
            this.verResponsivas = true
            this.verInventarios = true
            break
          case '120':
            console.log('120 - Asistente CORP')
            this.verInventarios = true
            this.verResponsivas = true
            this.verCombustibles = true
            this.verRequisiciones = true
            this.verSolicitudes = true
            break
          case '160':
            console.log('160 - AdminUser')
            this.verInventarios = true
            this.verResponsivas = true
            this.verCombustibles = true
            this.verRequisiciones = true
            this.verSolicitudes = true
            break
          case '240':
            console.log('240 - jefe operaciones')
            break
          case '310':
            console.log('310 - instrumentacion')
            break
          case '341':
            console.log('341 - facturacion')
            break
          case '342':
            console.log('342 - bascula')
            break
          case '343':
            console.log('343 - bascula y facturacion')
            break
          case '350':
            console.log('350 - mantenimiento')
            break
          case '250':
            console.log('250 - jefe mantto.')
            break
          case '370':
            console.log('370 - seguridad')
            break
          case '270':
            console.log('370 - seguridad')
            break
          case '990': 
          console.log('990 - default')
            this.verInventarios = true
            break
          case '429': 
          console.log('990 - default')
            this.verRegistro = true
            break
        
          default:
            console.log('NINGUNO')
            verResponsivas = false
            verRequisiciones = false
            verRegistro = false
            verReportes = false
            verSoporte = false
            verInventarios = false
            verCombustibles = false
            verSolicitudes = false
            verGIA = false
            isAlmacenistaCede = false
            break
        }
      }
      //this.checkSolicitudesPendientes()
      if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
        this.checkTickets()
      }
    },
    checkSolicitudesPendientes () {
      switch (this.userLogin.categoria) {
        case 0:
          console.log('gerentes')
          InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, 'ALL')
          .then( res => {
            let sol_depto = res.filter( sol => sol.estado === '2')
              if ( sol_depto.length > 0 ) {
                this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
              }
          })
          break
        case 2:
          console.log('jefes de area')
          switch (this.userLogin.departamento) {
            case 1:
              InventarioServices.getSolicitudes_area(this.userLogin.departamento, 'ALL')
              .then( res => {
                let sol_depto = res.filter( sol => parseInt(sol.estado) == 3)
                  if ( sol_depto.length > 0 ) {
                    this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                  }
              })
              break
            case 3:
              InventarioServices.getSolicitudes_area(this.userLogin.departamento, 'ALL')
              .then( res => {
                let sol_depto = res.filter( sol => parseInt(sol.estado) == 3)
                  if ( sol_depto.length > 0 ) {
                    this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                  }
              })
              break
          
            default:
              InventarioServices.getSolicitudes_depto(this.userLogin.departamento, 'ALL')
              .then( res => {
                let sol_depto = res.filter( sol => sol.estado === '1' && sol.ubicacion === this.userLogin.ubicacion)
                  if ( sol_depto.length > 0 ) {
                    this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                  }
              })
              break
          }
          break
        default:
        break
      }
      this.getFirmaCombustibles()
    },
    irReportes () {
      location.href = '/reportesApp/home.html'
    },
    getFirmaCombustibles() {
      //  1 Para Gerente GIA --- REVISÓ
      //  2 Para Gerente Admón --- AUTORIZÓ 
      InventarioServices.getFirmasPendientes_Comb(this.userLogin.id, 1)
        .then((data) => {
          let pendientes = parseInt(data[0].pendientes)
          if ( pendientes > 0) {
            let strPend = pendientes == 1? 'Firma Pendiente' : 'Firmas Pendientes'
            let mensaje = `${pendientes} ${strPend}`
            this.displayToast(mensaje,'done','Ir a Combustible', '/Transportes/Combustible/Resumen')
          }
        })
        .catch((e) => console.log(e))
    },
    checkTickets() {
      switch (parseInt(this.userLogin.categoria)) {
        case 0:
          ticketServices.searchAll()
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) == 3).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 2:
          ticketServices.searchTicket_area(this.userLogin.departamento)
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) == 3 && parseInt(tick.compra) == 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 3:
          ticketServices.searchTicket_user(this.userLogin.id, 'a')
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) < 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)

            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
      
        default:
          break
      }
    },
    sendNotification_tickets(ticketsPend) {
      if (ticketsPend > 0) {
        let textToast = ''
        if (ticketsPend == 1) {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} ticket pendiente.`
        } else {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} tickets pendientes.`
        }
        this.displayToast(textToast,'done','Ir a Soporte','/Soporte')
      }
    },
    displayToast(message, icon, actionText, destiny) {
      let toast = this.$toasted.show(message, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            console.log(destiny)
            this.$router.push(destiny)
            toastObject.goAway(0)
          }
        },
      })
    },
  },
  created () {
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }
</style>




// WEBPACK FOOTER //
// src/components/HomeCorp.vue